"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOptimizedVoteFieldValue = exports.isVoteFieldValue = void 0;
const dates_1 = require("./dates");
const objects_1 = require("./objects");
const primitives_1 = require("./primitives");
const arrays_1 = require("./arrays");
const custom_types_1 = require("./custom-types");
const typing_1 = require("./typing");
const isVoteFieldValue = (fieldValue) => {
    const isValidKeys = (0, objects_1.isObjectWithKeysValue)(fieldValue, ["total_votes", "votes"], true);
    const isVotesValid = (0, arrays_1.isArrayOfValidObjectsValue)(fieldValue.votes, {
        user_id: custom_types_1.isIDValue,
        date: dates_1.isDateAsStringValue,
    });
    const isTotalVotesValid = (0, primitives_1.isNumberValue)(fieldValue.total_votes);
    return isValidKeys && isVotesValid && isTotalVotesValid;
};
exports.isVoteFieldValue = isVoteFieldValue;
const isOptimizedVoteFieldValue = (fieldValue) => {
    return (0, objects_1.isValidObjectValue)(fieldValue, {
        total: primitives_1.isNumberValue,
        voted: (0, typing_1.Optional)(primitives_1.isOptimizedTrueValue),
    });
};
exports.isOptimizedVoteFieldValue = isOptimizedVoteFieldValue;
